module.exports = __webpack_public_path__ + "static/media/schuettler_mit_passiv.3bfe0115.png";